import React, { Component } from 'react';
import {
    CustomInput,
    CustomForm,
    CustomSelect,
    CustomButton,
    CustomFormLayout,
    CustomFormFooter
} from 'modules/form';
import { localizer } from 'utils/localizer';
import { createQuote } from '../../QuoteActions';
import AppStore from 'AppStore';
import Api from 'utils/api';

class CreateQuoteForm extends CustomForm {
    constructor(props) {
        super(props);
    }
    onSubmitHandler = () => {
        if (this.isFormValid()) {
            const form = this.serializeForm();
            createQuote(form);
        }
    };
    componentWillMount() {
        const profile = AppStore.getProfile();
        this.user = AppStore.getUser();
        this.leaseTypes = localizer.LEASE_TYPES;
        if (!profile) {
            this.leaseTypes = [{ Stretch: 'Stretch' }];
        }
        this.canAccessAdditionalFields =
            this.user.role == 'sales-rep' || this.user.role == 'broker';
        if (this.canAccessAdditionalFields) {
            this.setState({ loading: true });
        }
    }
    transformRateCardResponse = response => {
        const transformedJson = [];
        response.forEach(item => {
            transformedJson.push({
                [item.cardType]: item.id
            });
        });
        return transformedJson;
    };

    async componentDidMount() {
        const rateCardResp = await Api.getRateCards();
        this.setState({
            loading: false,
            rateCards: this.transformRateCardResponse(rateCardResp)
        });
    }

    getFeeAndRateCard = () => {
        if (!this.canAccessAdditionalFields) return '';

        return (
            <React.Fragment>
                <CustomInput
                    name="fee"
                    type="number"
                    label={localizer.QUOTES_LBL_FEE}
                    placeholder="%"
                    form={this}
                />
                <CustomSelect
                    name="rateCardId"
                    type="text"
                    label={localizer.QUOTES_LBL_RATE_CARD}
                    form={this}
                    options={this.state.rateCards}
                    defaultValue="E Card"
                />
            </React.Fragment>
        );
    };

    formBuilder = () => {
        //if loading ratecards show temp loading
        if (this.state.loading)
            return (
                <div className="loading" style={{ textAlign: 'center' }}>
                    Loading...
                </div>
            );

        //otherwise return rate card
        const feeAndRateCards = this.getFeeAndRateCard();
        return (
            <div className="create-quote-form ">
                <CustomFormLayout>
                    <CustomSelect
                        name="leaseType"
                        type="text"
                        label={localizer.QUOTES_LBL_LEASE_TYPE}
                        placeholder={localizer.COMPANY_NAME_PLACEHOLDER}
                        form={this}
                        options={this.leaseTypes}
                        defaultValue="Stretch"
                    />
                    <CustomInput
                        name="cost"
                        type="number"
                        label={localizer.QUOTES_LBL_EQUIPMENT_COST}
                        placeholder="$"
                        form={this}
                    />
                    {feeAndRateCards}

                    <CustomFormFooter>
                        <CustomButton
                            align="right"
                            type="primary-button"
                            action={this.onSubmitHandler}
                            label={localizer.QUOTES_BTN_CALC_QUOTE}
                            loading={this.props.loadingState}
                        />
                    </CustomFormFooter>
                </CustomFormLayout>
            </div>
        );
    };

    render() {
        const form = this.formBuilder();
        return form;
    }
}

export default CreateQuoteForm;



// WEBPACK FOOTER //
// ./src/modules/quote/pages/create-quote/CreateQuoteForm.jsx